import { TopSection } from './TopSection.jsx';
import { Workspace } from './Workspace.jsx';
import { Footer } from './Footer.jsx';

export function PlotterLayout() {
  return (
    <main className="app">
      <TopSection />
      <Workspace />
      <Footer />
    </main>
  );
}
